import Link from "next/link";
import { ChevronRight } from "lucide-react";

const slugify = (title) =>
  title.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "");

const JobAccordion = ({ jobs = [] }) => {
  return (
    <div className="max-w-3xl mx-auto p-6 space-y-4">
      {jobs.map((job) => {
        const slug = slugify(job.title);
        return (
          <Link
            key={job.id}
            href={`/career/apply/${slug}`}
            passHref
            legacyBehavior
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white border rounded-md shadow transition-all duration-300 hover:shadow-md hover:border-orange p-4"
            >
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="font-semibold text-lg text-gray-900">{job.title}</h3>
                  <p className="text-md text-gray-600">
                    {job.location} &nbsp;|&nbsp; {job.type} &nbsp;|&nbsp; Experience: {job.experience}
                  </p>
                </div>
                <ChevronRight size={20} className="text-orange" />
              </div>
            </a>
          </Link>
        );
      })}
    </div>
  );
};

export default JobAccordion;
